<template>
  <component
    :is="isLink ? 'a' : 'button'"
    :type="type"
    :href="isLink ? (disabled ? 'javascript:void(0)' : href) : undefined"
    :target="isLink ? target : undefined"
    :rel="isLink ? target : undefined"
    class="btn"
    :class="classesObject"
    :disabled="isButton ? disabled : undefined"
    @click="$emit('click', $event)"
  >
    <span v-if="loading" class="spinner-grow spinner-grow-sm" role="status" aria-hidden="true"></span>
    <slot></slot>
  </component>
</template>

<script>
import Vue from 'vue';

export default Vue.extend({
  props: {
    disabled: {
      type: Boolean,
      default: false,
    },

    loading: {
      type: Boolean,
      default: false,
    },

    active: {
      type: Boolean,
      default: false,
    },

    outline: {
      type: Boolean,
      default: false,
    },

    pill: {
      type: Boolean,
      default: false,
    },

    block: {
      type: Boolean,
      default: false,
    },

    size: {
      type: String,
      default: null,
      validator: function (value) {
        // The value must match one of these strings
        return ['sm', 'lg'].indexOf(value) !== -1;
      },
    },

    type: {
      type: String,
      default: 'button',
      validator: function (value) {
        // The value must match one of these strings
        return ['button', 'submit', 'reset'].indexOf(value) !== -1;
      },
    },

    variant: {
      type: String,
      default: 'primary',
      validator: function (value) {
        // The value must match one of these strings
        return (
          ['primary', 'secondary', 'warning', 'info', 'success', 'extra', 'danger', 'white', 'light', 'link'].indexOf(value) !==
          -1
        );
      },
    },

    href: {
      type: String,
      required: false,
    },

    target: {
      type: String,
      required: false,
    },

    rel: {
      type: String,
      required: false,
    },
  },

  computed: {
    classesObject() {
      let variant = '';

      if (this.variant === 'extra') {
        variant = 'extra';
      } else {
        if (this.outline) {
          variant = `btn-outline-${this.variant}`;
        } else {
          variant = `btn-${this.variant}`;
        }
      }

      let size = '';
      if (this.size !== null) {
        size = `btn-${this.size}`;
      }

      let block = '';
      if (this.block) {
        block = 'btn-block';
      }

      let pill = '';
      if (this.pill) {
        pill = 'pill';
      }

      let active = '';
      if (this.active) {
        active = 'active';
      }

      return `${variant} ${size} ${block} ${pill} ${active}`;
    },
    isLink() {
      return this.href;
    },
    isButton() {
      return !this.href;
    }
  },
});
</script>

<style lang="scss" scoped>
.pill {
  border-radius: 50px;
}
.extra {
  color: #0A1F44;
  border: 1px solid #0A1F44;
}
.extra:not(:disabled):hover {
  color: white;
  background: #0A1F44;
}
</style>
